import * as React from 'react';
import { TEAMSNAP_URL } from '../../core/constants';
import { useHistory } from 'react-router-dom';
import './forbidden.scss';

const Forbidden = (props) => {
  const history = useHistory();
  React.useEffect(
    () => () => {
      history.push({
        pathname: '/',
      });
    },
    []
  );

  return (
    <div className="forbidden-page">
      <div className="dialog">
        <a href={TEAMSNAP_URL}>
          <img src={TEAMSNAP_URL + '/images/teamsnap_title_nobg.png'} alt="TeamSnap" />
        </a>
        <h1>Oops! Looks like you're missing a backstage pass.</h1>
        <p>
          It looks like you're attempting to visit a page you don't have permission to access. You may want to speak
          with your Org Admin about your role, or if we goofed something up, please visit{' '}
          <a href="https://helpme.teamsnap.com/">Our Help Center</a>.
        </p>
        <img className="lock" src={TEAMSNAP_URL + '/images/icons/lock.png'} alt="Locked" />
        <div id="status">
          <h1>System Status</h1>
          <div id="official-system-status">
            All Systems Operational.{' '}
            <a href="https://status.teamsnap.com" target="_blank" rel="noreferrer">
              Check out our status page for more details.
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Forbidden;
